import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1 1 auto;\n  width: 100%;\n  box-sizing: border-box;\n  ", ";\n  ", ";\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  padding: ", ";\n  width: ", ";\n  height: ", ";\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  position: relative;\n  width: ", ";\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: row;\n  position: relative;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  flex: 1;\n  position: relative;\n  width: 100%;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  top: ", ";\n  left: ", ";\n  position: absolute;\n  z-index: 1;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  padding-right: ", ";\n  outline: none;\n  pointer-events: none;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  height: ", ";\n  padding: ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  flex: 1;\n  display: flex;\n  width: 100%;\n  border: none;\n  box-sizing: border-box;\n  background-color: transparent;\n  caret-color: ", ";\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  letter-spacing: ", ";\n  margin: 0;\n  ::-ms-clear,\n  ::-ms-reveal {\n    display: none;\n  }\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    /* display: none; <- Crashes Chrome on hover */\n    -webkit-appearance: none;\n    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */\n  }\n\n  ::placeholder {\n    position: relative;\n    color: ", " !important;\n    top: 0px;\n  }\n\n  &:focus {\n    outline: none;\n  }\n  padding: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  letter-spacing: ", ";\n  line-height: ", ";\n  margin-left: ", ";\n  pointer-events: none;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n\n  span {\n    color: transparent;\n  }\n  .slash {\n    color: ", ";\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  position: relative;\n  justify-content: space-between;\n  height: ", ";\n  max-width: ", ";\n  min-width: ", ";\n  background-color: ", ";\n  box-sizing: border-box;\n  border: ", " solid\n    ", ";\n  border-bottom: ", " solid\n    ", ";\n  ", ";\n\n  ", ";\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1 1 auto;\n  position: relative;\n  flex-direction: column;\n  input[type='number'] {\n    -moz-appearance: textfield; /* Firefox */\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  height: 100%;\n  flex-direction: ", ";\n\n  width: ", ";\n\n  max-width: ", ";\n  min-width: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import cuid from 'cuid';
import InputText from '../InputField/InputText';
import Label from '../Label/Label';
import Icon from '@vds-core/icons';
import { calculateRem } from '@uie/javascript-style-helpers';
import { BodyConfig, MicroConfig, TypographyConfig, Micro, Body } from '@vds-core/typography';
import { colors, calculateSpacing } from '@vds-core/theme';
import { creditCardOnChange, dateOnChange, _ignoreAlpha, _calculateCCMaxLength, _calculateDateMaxLength, determineMaxLength, _maskValue, _formatToPhone, stickyPlaceholderHTML, _taxIDOnChange } from './util/InputFormatting';
import { withVDSManager } from '@vds-core/utilities';

function _calculateInputPadding(error, readOnly, locked, type, readOnlyBorders) {
  if (type === 'calendar') {
    if ((readOnly || locked) && !readOnlyBorders) {
      return calculateRem(12, 16, 12, 32);
    } else {
      return calculateRem(12, 16, 12, 50);
    }
  } else {
    if ((readOnly || locked) && !readOnlyBorders) {
      return 0;
    } else {
      return calculateRem(12, 16);
    }
  }
}

var propTypes = {
  /**
   * If provided, the Input will be rendered in the Disabled State.
   */
  disabled: PropTypes.bool,

  /**
   * If provided, will provide the defaultValue for the input field.
   */
  defaultValue: PropTypes.any,

  /**
   * If provided, the Input will render placeholder text.
   */
  placeholder: PropTypes.string,

  /**
   * If provided, the Input will be rendered in the ReadOnly State.
   */
  readOnly: PropTypes.bool,

  /**
   * @ignore
   */
  name: PropTypes.string,

  /**
   * If provided, the Input will be rendered in the Error State.
   */
  error: PropTypes.bool,

  /**
   * If provided, an in the error state, the Input will render error text.
   */
  errorText: PropTypes.string,

  /**
   * If provided, will provide the context for the 'label' on the input field.
   */
  label: PropTypes.string,

  /**
   * If provided, will override the default sizing widths for the small and large datepicker input.
   */
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * If provided, this is a callback function for when input text is changed.
   */
  onChange: PropTypes.func,

  /**
   * @ignore
   */
  isOpen: PropTypes.bool,

  /**
   * If provided, used as string that labels the element for accessibility.
   */
  ariaLabel: PropTypes.string,

  /**
   * @deprecated
   * If provided, the Input will be rendered in the Locked State.
   */
  locked: PropTypes.bool,

  /**
   * When true, will add the required attribute to the input element, if false, a string of 'Optional' next to the label
   */
  required: PropTypes.bool,

  /**
   * @ignore - config for passing through icons
   */
  iconConfig: PropTypes.object,

  /**
   * @ignore - config for passing through other colors
   */
  color: PropTypes.object,

  /**
   * @ignore - config for passing though typography
   */
  bodyConfig: PropTypes.object,

  /**
   * @ignore - passes through typescale via sting if there's more than one option [example 'VDS' instead of 'MVP']
   */
  typescale: PropTypes.string,

  /**
   * @ignore - adds max-width to input field
   */
  maxWidth: PropTypes.string,

  /**
   * @ignore - adds min-width to input field
   */
  minWidth: PropTypes.string,

  /**
   * @ignore - adds hover state to input field
   */
  hoverState: PropTypes.bool,

  /**
   * @ignore - adds or removes focus states
   */
  focusState: PropTypes.bool,

  /**
   * @ignore - number representing height of input field
   */
  inputHeight: PropTypes.string,

  /**
   * @ignore - padding on the inside of the input field
   */
  calculateInputPadding: PropTypes.func,

  /**
   * @ignore - spacing between the label and the input field
   */
  labelMarginBottom: PropTypes.string,

  /**
   * @ignore - defines whether text trancates with ellipsis or not
   */
  overflowEllipsis: PropTypes.bool,

  /**
   * @ignore
   * spacing between the label and the input field
   */
  value: PropTypes.string,

  /**
   * @ignore - adds the ability to use borders when in ready only state (default is borderless)
   */
  readOnlyBorders: PropTypes.bool,

  /**
   * @ignore renders Error icon if true
   */
  renderErrorIcon: PropTypes.bool,

  /**
   * @ignore string representing the type of input
   */
  type: PropTypes.string,

  /**
   * @ignore If passed, new TextLink component will render for inlineAction
   */
  TextLink: PropTypes.func,

  /**
   * @ignore If passed, new Body component will render
   */
  Body: PropTypes.func,

  /**
   * @ignore If passed, new Micro component will render
   */
  Micro: PropTypes.func,

  /**
   * Allows a unique ID to be passed to the component.
   */
  id: PropTypes.string,

  /**
   * Allows a unique ID to be passed to the input element.
   */
  inputId: PropTypes.string,

  /**
   * @ignore If passed, the CreditCardIcon will render
   */
  CreditCardIcon: PropTypes.func,

  /**
   * @ignore If passed, the Tooltip will render
   */
  Tooltip: PropTypes.func,

  /**
   *  If passed, sets Max character length for input field
   */
  maxLength: PropTypes.number
};
var defaultProps = {
  disabled: false,
  error: false,
  locked: false,
  readOnly: false,
  label: undefined,
  isOpen: false,
  ariaLabel: 'text input',
  inputHeight: calculateRem(42),
  required: true,
  color: colors,
  bodyConfig: BodyConfig,
  iconConfig: undefined,
  typescale: TypographyConfig.getTypescale(),
  maxWidth: undefined,
  minWidth: undefined,
  focusState: false,
  hoverState: false,
  labelMarginBottom: calculateRem(1),
  overflowEllipsis: false,
  calculateInputPadding: _calculateInputPadding,
  readOnlyBorders: false,
  Body: Body,
  Micro: Micro,
  renderErrorIcon: false,
  TextLink: undefined,
  type: undefined,
  CreditCardIcon: undefined,
  Tooltip: undefined //Deprecated
  // locked: false

};
var ComponentContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "ComponentContainer",
  componentId: "q2v02a-0"
})(_templateObject(), function (_ref) {
  var helperTextPlacement = _ref.helperTextPlacement;
  return helperTextPlacement === 'right' ? 'row' : 'column';
}, function (_ref2) {
  var containerWidth = _ref2.containerWidth;
  return containerWidth ? typeof containerWidth === 'number' ? calculateRem(containerWidth) : containerWidth : '100%';
}, function (_ref3) {
  var maxWidth = _ref3.maxWidth;
  return calculateRem(maxWidth);
}, function (_ref4) {
  var minWidth = _ref4.minWidth;
  return calculateRem(minWidth);
});
var StyledContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledContainer",
  componentId: "q2v02a-1"
})(_templateObject2());
var InputContainer = /*#__PURE__*/styled.span.withConfig({
  displayName: "InputContainer",
  componentId: "q2v02a-2"
})(_templateObject3(), function (_ref5) {
  var inputHeight = _ref5.inputHeight;
  return inputHeight;
}, function (_ref6) {
  var maxWidth = _ref6.maxWidth;
  return maxWidth && calculateRem(maxWidth);
}, function (_ref7) {
  var minWidth = _ref7.minWidth;
  return minWidth && calculateRem(minWidth);
}, function (_ref8) {
  var color = _ref8.color;
  return color.secondary;
}, calculateRem(1), function (_ref9) {
  var color = _ref9.color,
      error = _ref9.error,
      isOpen = _ref9.isOpen,
      disabled = _ref9.disabled,
      focused = _ref9.focused;
  return isOpen || focused ? color.black : error && !disabled ? color.error : color.coolGray3;
}, calculateRem(1), function (_ref10) {
  var color = _ref10.color,
      disabled = _ref10.disabled;
  return disabled ? color.coolGray3 : color.black;
}, function (_ref11) {
  var readOnlyBorders = _ref11.readOnlyBorders,
      readOnly = _ref11.readOnly,
      locked = _ref11.locked,
      color = _ref11.color;
  return (readOnly || locked) && "\n      border: ".concat(readOnlyBorders ? "".concat(calculateRem(1), " solid ").concat(color.coolGray3) : 'none', ";\n  ");
}, function (_ref12) {
  var hoverState = _ref12.hoverState,
      readOnly = _ref12.readOnly,
      error = _ref12.error,
      success = _ref12.success,
      disabled = _ref12.disabled,
      color = _ref12.color;
  return hoverState && "\n      &:hover {\n        border: ".concat(calculateRem(1), " solid ").concat(readOnly || disabled ? color.coolGray3 : color.black, ";\n      border-bottom: ").concat(calculateRem(1), " solid ").concat(readOnly || disabled ? color.coolGray3 : error ? color.error : success ? color.green : color.black, ";\n  }\n  ");
}, function (_ref13) {
  var error = _ref13.error,
      success = _ref13.success,
      disabled = _ref13.disabled,
      color = _ref13.color,
      helperTextPlacement = _ref13.helperTextPlacement,
      errorText = _ref13.errorText,
      successText = _ref13.successText,
      label = _ref13.label;
  return (error || success) && !disabled && "\n    &::before {\n      background:  ".concat(error ? color.orange : color.green, ";\n      box-shadow: none;\n      content: '';\n      height: ").concat(calculateRem(4), ";\n      left: ").concat(-1, "px;\n      position: absolute;\n      bottom: ").concat(-1, "px;\n      width: calc(100% + ").concat(calculateRem(2), ");\n      z-index: 1;\n    }\n  ");
});
var StickyPlaceholder = /*#__PURE__*/styled.div.withConfig({
  displayName: "StickyPlaceholder",
  componentId: "q2v02a-3"
})(_templateObject4(), function (_ref14) {
  var color = _ref14.color,
      disabled = _ref14.disabled;
  return disabled ? color.coolGray3 : color.coolGray6;
}, function (_ref15) {
  var body = _ref15.body;
  return body.fontFamily;
}, function (_ref16) {
  var body = _ref16.body;
  return calculateRem(body.fontSize);
}, function (_ref17) {
  var body = _ref17.body;
  return calculateRem(body.letterSpacing);
}, function (_ref18) {
  var body = _ref18.body;
  return calculateRem(body.lineHeight);
}, calculateSpacing('3X'), function (_ref19) {
  var color = _ref19.color,
      disabled = _ref19.disabled;
  return disabled ? color.coolGray3 : color.black;
});
var StyledInput = /*#__PURE__*/styled.input.withConfig({
  displayName: "StyledInput",
  componentId: "q2v02a-4"
})(_templateObject5(), function (_ref20) {
  var color = _ref20.color;
  return color.black;
}, function (_ref21) {
  var color = _ref21.color,
      disabled = _ref21.disabled,
      type = _ref21.type;
  return type === 'date' ? color.white : disabled ? color.coolGray3 : color.black;
}, function (_ref22) {
  var body = _ref22.body;
  return body.fontFamily;
}, function (_ref23) {
  var body = _ref23.body;
  return calculateRem(body.fontSize);
}, function (_ref24) {
  var body = _ref24.body;
  return calculateRem(body.lineHeight);
}, function (_ref25) {
  var body = _ref25.body,
      masked = _ref25.masked;
  return masked ? calculateSpacing('1X') : calculateRem(body.letterSpacing);
}, function (_ref26) {
  var color = _ref26.color;
  return color.coolGray3;
}, function (_ref27) {
  var calculateInputPadding = _ref27.calculateInputPadding,
      error = _ref27.error,
      readOnly = _ref27.readOnly,
      locked = _ref27.locked,
      trueType = _ref27.trueType,
      readOnlyBorders = _ref27.readOnlyBorders;
  return calculateInputPadding(error, readOnly, locked, trueType, readOnlyBorders);
});
var ActionWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "ActionWrapper",
  componentId: "q2v02a-5"
})(_templateObject6(), calculateRem(20), calculateRem(12, 12, 12, 0));
var IconContainer = /*#__PURE__*/styled.span.withConfig({
  displayName: "IconContainer",
  componentId: "q2v02a-6"
})(_templateObject7(), function (_ref28) {
  var type = _ref28.type;
  return (type === 'inlineAction' || type === 'taxID') && calculateSpacing('2X');
});
var CalendarIconWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "CalendarIconWrapper",
  componentId: "q2v02a-7"
})(_templateObject8(), function (_ref29) {
  var typescale = _ref29.typescale;
  return typescale === 'VDS' ? '12px' : '11px';
}, function (_ref30) {
  var readOnly = _ref30.readOnly,
      readOnlyBorders = _ref30.readOnlyBorders;
  return readOnly && !readOnlyBorders ? 0 : readOnlyBorders ? '12px' : '16px';
});
var InputWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "InputWrapper",
  componentId: "q2v02a-8"
})(_templateObject9());
var FlexedRowContainer = /*#__PURE__*/styled.span.withConfig({
  displayName: "FlexedRowContainer",
  componentId: "q2v02a-9"
})(_templateObject10());
var FlexedColContainer = /*#__PURE__*/styled.span.withConfig({
  displayName: "FlexedColContainer",
  componentId: "q2v02a-10"
})(_templateObject11(), function (_ref31) {
  var helperText = _ref31.helperText,
      helperTextPlacement = _ref31.helperTextPlacement;
  return helperText && helperTextPlacement === 'right' ? '50%' : '100%';
});
var CardIconContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "CardIconContainer",
  componentId: "q2v02a-11"
})(_templateObject12(), calculateRem(12, 0, 12, 12), calculateRem(32), calculateRem(20));
var HelperText = /*#__PURE__*/styled.div.withConfig({
  displayName: "HelperText",
  componentId: "q2v02a-12"
})(_templateObject13(), function (_ref32) {
  var helperTextPlacement = _ref32.helperTextPlacement,
      label = _ref32.label;
  return helperTextPlacement === 'right' && "\n    position: relative;\n    width: 50%;\n    padding-top: 0px;\n    padding-left: ".concat(calculateSpacing('3X'), ";\n  ");
}, function (_ref33) {
  var helperTextPlacement = _ref33.helperTextPlacement;
  return helperTextPlacement === 'bottom' && "\n    padding-top: ".concat(calculateSpacing('2X'), ";\n  ");
});

var InputField = /*#__PURE__*/function (_React$Component) {
  _inherits(InputField, _React$Component);

  var _super = _createSuper(InputField);

  function InputField(props) {
    var _this;

    _classCallCheck(this, InputField);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps, prevState) {
      if (prevProps.value !== _this.props.value && _this.isControlled) {
        _this.setState({
          value: _this.props.value
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (e) {
      _this.props.onClickInlineAction && _this.props.onClickInlineAction(e); // if (this.props.type === 'taxID') {
      //   let clean = this.state.formattedValue.replace(/\D/g, '');
      //   if (!this.state.hidden) {
      //     this.setState({ value: clean });
      //   } else {
      //     this.setState({ value: this.state.formattedValue });
      //   }
      //   this.setState({ hidden: !this.state.hidden });
      // }
    });

    _defineProperty(_assertThisInitialized(_this), "_renderIcon", function () {
      var _this$props = _this.props,
          type = _this$props.type,
          iconConfig = _this$props.iconConfig,
          error = _this$props.error,
          success = _this$props.success,
          color = _this$props.color;
      return /*#__PURE__*/React.createElement(IconContainer, {
        tabIndex: -1,
        type: type
      }, /*#__PURE__*/React.createElement(Icon, {
        tabIndex: -1,
        hasStroke: true,
        data: iconConfig,
        size: "medium",
        name: error ? 'error' : 'success',
        color: color.black
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "_renderCalendarIcon", function () {
      var _this$props2 = _this.props,
          iconConfig = _this$props2.iconConfig,
          calendarIconColor = _this$props2.calendarIconColor,
          readOnly = _this$props2.readOnly,
          readOnlyBorders = _this$props2.readOnlyBorders,
          label = _this$props2.label,
          typescale = _this$props2.typescale;
      return /*#__PURE__*/React.createElement(CalendarIconWrapper, {
        typescale: typescale,
        readOnlyBorders: readOnlyBorders,
        readOnly: readOnly,
        label: label
      }, /*#__PURE__*/React.createElement(Icon, {
        style: {
          position: 'relative'
        },
        data: iconConfig,
        tabIndex: -1,
        name: "calendar",
        size: "medium",
        color: calendarIconColor
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "_renderInlineAction", function () {
      var _this$props3 = _this.props,
          type = _this$props3.type,
          disabled = _this$props3.disabled,
          readOnly = _this$props3.readOnly,
          inlineActionButtonLabel = _this$props3.inlineActionButtonLabel,
          showPasswordButtonLabel = _this$props3.showPasswordButtonLabel,
          hidePasswordButtonLabel = _this$props3.hidePasswordButtonLabel,
          TextLink = _this$props3.TextLink; // let inlineActionText, inlineActionAriaLabel;
      // if (type === 'taxID') {
      //   if (this.state.hidden) {
      //     inlineActionText = showPasswordButtonLabel;
      //     inlineActionAriaLabel = `${showPasswordButtonLabel} tax ID number`;
      //   } else {
      //     inlineActionText = hidePasswordButtonLabel;
      //     inlineActionAriaLabel = `${hidePasswordButtonLabel} tax ID number`;
      //   }
      // }

      return /*#__PURE__*/React.createElement(TextLink, {
        type: "standAlone",
        size: "large",
        viewport: "desktop",
        disabled: disabled || readOnly,
        onClick: _this._onClick,
        ariaLabel: inlineActionButtonLabel
      }, inlineActionButtonLabel);
    });

    _defineProperty(_assertThisInitialized(_this), "_onChange", function (e) {
      var _this$props4 = _this.props,
          dateFormat = _this$props4.dateFormat,
          type = _this$props4.type,
          onChange = _this$props4.onChange,
          taxIDFormat = _this$props4.taxIDFormat;
      onChange && onChange(e);
      var obj;
      var fromOnChange = true;

      switch (type) {
        case 'creditCard':
          e.target.value = _ignoreAlpha(e);
          obj = creditCardOnChange(e, _this.state.value, _this.state.cardType, fromOnChange);
          return _this.setState({
            value: obj.value,
            cardType: obj.cardType
          });

        case 'tel':
          obj = _formatToPhone(e, _this.state.value, fromOnChange);
          _formatToPhone;
          return _this.setState({
            value: obj.value
          });

        case 'date':
          e.target.value = _ignoreAlpha(e);
          obj = dateOnChange(e, _this.state.value, dateFormat);
          return _this.setState({
            value: obj.value
          });
        // case 'taxID':
        //   e.target.value = _ignoreAlpha(e);
        //   let targetValue = e.target.value;
        //   obj = _taxIDOnChange(
        //     e,
        //     this.state.value,
        //     this.state.hidden,
        //     taxIDFormat
        //   );
        //   return this.setState({
        //     formattedValue: obj.formattedValue,
        //     value: this.state.hidden ? targetValue : obj.value,
        //   });

        case 'securityCode':
          e.target.value = _ignoreAlpha(e);

        default:
          return !_this.isControlled && _this.setState({
            value: e.target.value
          });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_determineInputType", function () {
      var _this$props5 = _this.props,
          type = _this$props5.type,
          readOnly = _this$props5.readOnly,
          locked = _this$props5.locked;
      var hidden = _this.state.hidden;

      if (type === 'taxID') {
        if (hidden || readOnly || locked) {
          return 'password';
        } else {
          return 'text';
        }
      } else if (type === 'password' || type === 'securityCode') {
        return 'password';
      } else if (type === 'calendar' || type === 'date') {
        return 'text';
      }

      return type;
    });

    _defineProperty(_assertThisInitialized(_this), "_determineValue", function () {
      var _this$props6 = _this.props,
          type = _this$props6.type,
          readOnly = _this$props6.readOnly,
          value = _this$props6.value,
          defaultValue = _this$props6.defaultValue;

      if (value || defaultValue) {
        return value;
      } else if (type === 'creditCard' && readOnly) {
        return _maskValue(_this.state.value, _this.state.cardType);
      } else if (type === 'taxID' && readOnly) {
        var clean = _this.state.formattedValue.replace(/\D/g, '');

        return clean;
      } else if (type === 'creditCard' && _this.state.maskCC) {
        return _maskValue(_this.state.value, _this.state.cardType);
      } else {
        return _this.state.value;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_renderStickyPlaceholder", function (body) {
      var value = _this.state.value;
      var _this$props7 = _this.props,
          color = _this$props7.color,
          disabled = _this$props7.disabled,
          type = _this$props7.type,
          dateFormat = _this$props7.dateFormat,
          error = _this$props7.error,
          success = _this$props7.success;

      if (type === 'date') {
        return /*#__PURE__*/React.createElement(StickyPlaceholder, {
          success: success,
          error: error,
          body: body,
          color: color,
          disabled: disabled
        }, stickyPlaceholderHTML(dateFormat, value));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_renderHelperText", function () {
      var _this$props8 = _this.props,
          label = _this$props8.label,
          helperText = _this$props8.helperText,
          helperTextPlacement = _this$props8.helperTextPlacement,
          bodyConfig = _this$props8.bodyConfig,
          disabled = _this$props8.disabled,
          color = _this$props8.color,
          typescale = _this$props8.typescale,
          Body = _this$props8.Body;
      return /*#__PURE__*/React.createElement(HelperText, {
        "aria-hidden": "true",
        label: label,
        helperTextPlacement: helperTextPlacement
      }, /*#__PURE__*/React.createElement(Body, {
        config: bodyConfig,
        color: disabled ? color.coolGray3 : color.coolGray6,
        typescale: typescale
      }, helperText));
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function () {
      var _this$props9 = _this.props,
          type = _this$props9.type,
          readOnly = _this$props9.readOnly;

      if (!readOnly) {
        if ((type === 'securityCode' || type === 'creditCard') && _this.state.value.length > 0) {
          _this.setState({
            value: '',
            cardType: 'placeholder',
            maskCC: false
          });
        }

        _this.setState({
          focused: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function () {
      var _this$props10 = _this.props,
          type = _this$props10.type,
          readOnly = _this$props10.readOnly;

      if (!readOnly) {
        if (type === 'creditCard' && _this.state.value.length > 0) {
          _this.setState({
            maskCC: true
          });
        }

        _this.setState({
          focused: false
        });
      }
    });

    _this.state = {
      cardType: 'placeholder',
      value: _this.props.value && _this.props.type === 'text' ? _this.props.value : _this.props.defaultValue && _this.props.type === 'text' ? _this.props.defaultValue : '',
      hidden: true,
      focused: false,
      formattedValue: '',
      maskCC: false
    };
    return _this;
  }

  _createClass(InputField, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.isControlled = this.props.type === 'text' && this.props.value !== undefined || this.props.defaultValue !== undefined;
    }
  }, {
    key: "render",
    value: function render() {
      var _React$createElement;

      var _this$props11 = this.props,
          locked = _this$props11.locked,
          value = _this$props11.value,
          readOnly = _this$props11.readOnly,
          error = _this$props11.error,
          label = _this$props11.label,
          errorText = _this$props11.errorText,
          disabled = _this$props11.disabled,
          width = _this$props11.width,
          isOpen = _this$props11.isOpen,
          ariaLabel = _this$props11.ariaLabel,
          required = _this$props11.required,
          bodyConfig = _this$props11.bodyConfig,
          color = _this$props11.color,
          typescale = _this$props11.typescale,
          minWidth = _this$props11.minWidth,
          maxWidth = _this$props11.maxWidth,
          hoverState = _this$props11.hoverState,
          calculateInputPadding = _this$props11.calculateInputPadding,
          labelMarginBottom = _this$props11.labelMarginBottom,
          overflowEllipsis = _this$props11.overflowEllipsis,
          readOnlyBorders = _this$props11.readOnlyBorders,
          focusState = _this$props11.focusState,
          placeholder = _this$props11.placeholder,
          id = _this$props11.id,
          renderErrorIcon = _this$props11.renderErrorIcon,
          iconConfig = _this$props11.iconConfig,
          type = _this$props11.type,
          inputHeight = _this$props11.inputHeight,
          dateFormat = _this$props11.dateFormat,
          CreditCardIcon = _this$props11.CreditCardIcon,
          Tooltip = _this$props11.Tooltip,
          tooltipTitle = _this$props11.tooltipTitle,
          tooltipContent = _this$props11.tooltipContent,
          helperTextPlacement = _this$props11.helperTextPlacement,
          helperText = _this$props11.helperText,
          success = _this$props11.success,
          successText = _this$props11.successText,
          Body = _this$props11.Body,
          Micro = _this$props11.Micro,
          taxIDFormat = _this$props11.taxIDFormat,
          cardBrand = _this$props11.cardType,
          onClickInlineAction = _this$props11.onClickInlineAction,
          maxLength = _this$props11.maxLength,
          className = _this$props11.className,
          inputId = _this$props11.inputId,
          rest = _objectWithoutProperties(_this$props11, ["locked", "value", "readOnly", "error", "label", "errorText", "disabled", "width", "isOpen", "ariaLabel", "required", "bodyConfig", "color", "typescale", "minWidth", "maxWidth", "hoverState", "calculateInputPadding", "labelMarginBottom", "overflowEllipsis", "readOnlyBorders", "focusState", "placeholder", "id", "renderErrorIcon", "iconConfig", "type", "inputHeight", "dateFormat", "CreditCardIcon", "Tooltip", "tooltipTitle", "tooltipContent", "helperTextPlacement", "helperText", "success", "successText", "Body", "Micro", "taxIDFormat", "cardType", "onClickInlineAction", "maxLength", "className", "inputId"]);

      var _this$state = this.state,
          cardType = _this$state.cardType,
          focused = _this$state.focused;
      var fieldId = inputId ? inputId : cuid();
      var fontSize = typescale === 'VDS' ? 'large' : 'medium';
      var body = bodyConfig.getStyles(typescale, 'desktop', fontSize);
      var renderIcon = renderErrorIcon && (error || success) && !focused && !(readOnly || locked);
      var renderInlineAction = (type === 'inlineAction' || type === 'taxID') && !(readOnly || locked);
      var labelId = fieldId + ' label';
      var accessLabel = label ? !required ? label + ' Optional Input Field' : label + ' Input Field' : ariaLabel;
      error && !errorText && console.error('Error Text for Input MUST be provided');
      return /*#__PURE__*/React.createElement(ComponentContainer, {
        helperTextPlacement: helperTextPlacement,
        minWidth: minWidth,
        maxWidth: maxWidth,
        containerWidth: width,
        className: className
      }, /*#__PURE__*/React.createElement(StyledContainer, {
        id: id,
        "data-testid": "test-container",
        helperTextPlacement: helperTextPlacement,
        helperText: helperText
      }, label && /*#__PURE__*/React.createElement(Label, (_React$createElement = {
        typescale: typescale,
        Body: Body,
        Micro: Micro,
        width: width,
        disabled: disabled,
        color: color,
        required: required,
        label: label,
        Tooltip: Tooltip,
        tooltipTitle: tooltipTitle,
        tooltipContent: tooltipContent,
        type: type,
        "data-testid": "test-label",
        id: labelId
      }, _defineProperty(_React$createElement, "width", width), _defineProperty(_React$createElement, "aria-label", label), _defineProperty(_React$createElement, "htmlFor", fieldId), _defineProperty(_React$createElement, "cardType", cardBrand), _defineProperty(_React$createElement, "focusState", focusState), _defineProperty(_React$createElement, "labelMarginBottom", labelMarginBottom), _defineProperty(_React$createElement, "overflowEllipsis", overflowEllipsis), _defineProperty(_React$createElement, "helperTextPlacement", helperTextPlacement), _defineProperty(_React$createElement, "helperText", helperText), _defineProperty(_React$createElement, "CreditCardIcon", CreditCardIcon), _React$createElement)), /*#__PURE__*/React.createElement(FlexedRowContainer, null, /*#__PURE__*/React.createElement(FlexedColContainer, {
        helperText: helperText,
        helperTextPlacement: helperTextPlacement
      }, type === 'calendar' && this._renderCalendarIcon(), /*#__PURE__*/React.createElement(InputContainer, {
        readOnlyBorders: readOnlyBorders,
        minWidth: minWidth,
        maxWidth: maxWidth,
        color: color,
        error: error,
        disabled: disabled,
        isOpen: isOpen,
        hoverState: hoverState,
        type: type,
        inputHeight: inputHeight,
        success: success,
        helperText: helperText,
        helperTextPlacement: helperTextPlacement,
        successText: successText,
        errorText: errorText,
        label: label,
        readOnly: locked || readOnly,
        locked: locked || readOnly,
        onFocus: this._onFocus,
        onBlur: this._onBlur,
        focused: this.state.focused
      }, type === 'creditCard' && /*#__PURE__*/React.createElement(CardIconContainer, {
        error: error,
        cardType: cardType,
        success: success
      }, /*#__PURE__*/React.createElement(CreditCardIcon, {
        name: cardType
      })), /*#__PURE__*/React.createElement(InputWrapper, null, /*#__PURE__*/React.createElement(StyledInput, _extends({
        maxLength: determineMaxLength(this.state.cardType, type, dateFormat, taxIDFormat, this.state.hidden, cardBrand, maxLength),
        "data-testid": "test-input",
        "data-truevalue": (type === 'creditCard' || type === 'tel') && this.state.value ? this.state.value.replace(/\D/g, '') : '',
        placeholder: placeholder,
        body: body,
        color: color,
        "aria-label": helperText ? "".concat(accessLabel, " ").concat(helperText) : accessLabel,
        id: fieldId,
        autocomplete: "off",
        inputHeight: inputHeight
      }, rest, {
        disabled: disabled,
        error: error,
        locked: locked,
        trueType: type,
        readOnlyBorders: readOnlyBorders,
        required: false,
        readOnly: readOnly || locked,
        onChange: this._onChange,
        value: type === 'password' ? this.props.value : this._determineValue(),
        masked: this._determineInputType() === 'password',
        type: this._determineInputType(),
        calculateInputPadding: calculateInputPadding
      })), type === 'date' && this._renderStickyPlaceholder(body)), (renderIcon || renderInlineAction) && /*#__PURE__*/React.createElement(ActionWrapper, {
        error: error,
        success: success
      }, renderIcon && this._renderIcon(), renderInlineAction && this._renderInlineAction())), (error && errorText || success && successText) && /*#__PURE__*/React.createElement(InputText, {
        bodyConfig: bodyConfig,
        typescale: typescale
      }, error ? errorText : successText)), helperText && helperTextPlacement === 'right' && this._renderHelperText()), helperText && helperTextPlacement === 'bottom' && this._renderHelperText()));
    }
  }]);

  return InputField;
}(React.Component);

InputField.defaultProps = defaultProps;
InputField.propTypes = propTypes;
/**
 * @component
 */

export default withVDSManager(InputField);